import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=23fb8082"
import script from "./userlist.vue?vue&type=script&lang=js"
export * from "./userlist.vue?vue&type=script&lang=js"
import style0 from "./userlist.vue?vue&type=style&index=0&id=23fb8082&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports